import './Header.sass';

import React from 'react';
import {connect} from 'react-redux';
import {FormattedMessage, injectIntl} from 'react-intl';

import brandLogo from './assets/logo.svg';

import cx from 'classnames';

import withMediaQueries from '../../containers/withMediaQueries/withMediaQueries';
import WalletCheckoutModalContainer from '../../containers/walletDepositModalContainer/WalletDepositModalContainer';
import SearchBarContainer from '../../containers/searchBarContainer/SearchBarContainer';
import ChannelDropdown from '../../containers/channelUtils/ChannelDropdown';
import MainTaxonDropdown from '../../containers/mainTaxonDropdown/MainTaxonDropdown';
import UserDropdown from '../../containers/userDropdown/UserDropdown';
import ChannelPrice from '../../containers/channelUtils/ChannelPrice';
import ChannelLink from '../../containers/channelUtils/ChannelLink';
import Button from '../../components/button/Button';
import {openModal} from '../../ducks/ui';

import ReviewsTotal from '../reviews/ReviewsTotal';

import HeaderSideMenu from './HeaderSideMenu';

@injectIntl
@withMediaQueries({collapsed: '(max-width: 991px)'}, {collapsed: false})
@connect(({user}) => ({userProfile: user.profile}))
export default class Header extends React.PureComponent {
  buildMenu = () => {
    const menu = [
      { name: 'section.header.how', to: '/how-it-works' },
      // Temporarily hidden — restore to show "Work with us" in the header.
      // { name: 'section.generic.work', to: '/work-with-us' },
    ];

    menu.splice(1, 0, { name: 'section.generic.reviews', to: '/reviews' });

    return menu;
  };

  constructor(props) {
    super(props);

    this.state = {isMenuOpen: false};
  }

  addBalance = () => {
    this.props.dispatch(openModal(WalletCheckoutModalContainer));
  };

  render() {
    const menu = this.buildMenu();

    const {userProfile, collapsed, loggedIn, cartItemsCount, minimal, onProfileClick, onLoginClick, onContactClick, onCartClick} = this.props;

    if (minimal) {
      return (
        <header className="header header--minimal">
          <div className="header__minimal-inner">
            <ChannelLink to='/' className="header__logo" aria-label="Boosthive">
              <img src={brandLogo} width={230} height={36} alt="Boosthive"/>
            </ChannelLink>
          </div>
        </header>
      );
    }

    return (
      <header className={cx('header', this.state.isMenuOpen && 'header--mobile-open')}>
        <div className="header__top">
          <div className="container">
            <div className="row">
              <div className="header__top-left">
                <nav className="header__links">
                  {menu.map(({name, to}, idx) => (
                    <ChannelLink
                      key={idx}
                      className="header__link"
                      to={to}
                    >
                      <FormattedMessage id={name}/>
                    </ChannelLink>
                  ))}
                </nav>

                <div className="header__search">
                  <SearchBarContainer/>
                </div>
              </div>

              <div className="header__top-right">
                <div className="header__channel-dropdown">
                  <ChannelDropdown/>
                </div>

                {loggedIn ? (
                  <React.Fragment>
                    <div className='header__funds' onClick={this.addBalance}>
                      <ChannelPrice className="hea" price={userProfile && userProfile.wallet && userProfile.wallet.balance} />

                      <div className="header__funds-add">
                        <div className='header__funds-add-icon' />
                      </div>
                    </div>

                    <div className="header__profile">
                      <UserDropdown/>
                    </div>
                  </React.Fragment>
                ) : (
                  <div className="header__login">
                    <Button onClick={onLoginClick}><FormattedMessage id="section.auth.sign-in.action"/></Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="header__bottom">
          <div className="container">
            <div className="row">
              <div className="header__bottom-left">
                <ChannelLink to='/' className="header__logo">
                  <img src={brandLogo} width={260} height={41} alt="Boosthive"/>
                </ChannelLink>

                {/*<MainTaxonDropdown/>*/}

                <div className="header__reviews  header__reviews--desktop">
                  <ReviewsTotal isHeaderVariant />
                </div>
              </div>

              <div className="header__bottom-right">
                {loggedIn && (
                  <div className='header__funds header__funds-mobile' onClick={this.addBalance}>
                    <ChannelPrice price={userProfile && userProfile.wallet && userProfile.wallet.balance} />

                    <div className="header__funds-add">
                      <div className='header__funds-add-icon' />
                    </div>
                  </div>
                )}

                <Button onClick={onCartClick} className="header__cart" aria-label="Cart">
                  <span className="header__cart-counter">
                    <span className="header__cart-counter-icon"/>
                      {!!cartItemsCount && (
                        <span className="header__cart-counter-number">
                          {cartItemsCount}
                        </span>
                      )}
                    </span>
                  <span className="header__cart-text">
                    <FormattedMessage id="section.header.cart"/>
                  </span>
                </Button>

                <button className="header__menu" aria-label="Menu" onClick={() => this.setState({isMenuOpen: true})}/>

                {collapsed && <HeaderSideMenu
                  items={menu}
                  isOpen={this.state.isMenuOpen}
                  onStateChange={isMenuOpen => this.setState({isMenuOpen})}
                  onProfileClick={onProfileClick}
                  onContactClick={onContactClick}
                />}
              </div>
            </div>
          </div>
        </div>

        <div className="header__reviews  header__reviews--mobile">
          <div className="container">
            <ReviewsTotal isHeaderVariant />
          </div>
        </div>
      </header>
    );
  }
}



// WEBPACK FOOTER //
// ./components/header/Header.js